import React from "react";
import PropTypes from "prop-types";
import { Select, Row, Col, Form } from "antd";
import moment from "moment";
import {
  ErrorMsgWrap,
  LabelWrapper,
  InputWrapper,
  FormContainer,
  GrantDropdown,
  SelectOptionWrapper,
  GrantDatePicker,
  AlertWrap,
} from "../../style";
import FormBase from "../../../../../../CommonComponents/FormBase/FormBase";
import { isFutureDate } from "../../../../../../utils/commonUtil";
import regexMap from "../../../../../../utils/regexMap";
import CurrencyInput from "../../../../../../CommonComponents/CurrencyInput/CurrencyInput";
import ErrorPopup from "../../../../../../CommonComponents/ErrorPopup/ErrorPopup";
import { SectionContent } from "../../../../../../CommonComponents/commonStyles";
import {
  AlertContent,
  Types,
} from "../../../../../../CommonComponents/ContentMessages";
import formatter from "../../../../../../utils/formatter"
class OneTimeGrantsForm extends FormBase {
  constructor(props) {
    super(props);
    // if available balance is less than $500, make available balance min grant amount
    this.minGrantAmount = 500;
    this.state = {
      amount: {
        value: props.amount || "",
        valid: "",
        touched: false,
        disabled: props.amountLocked || false,
        matchPattern: regexMap.twoDecimal,
        validationRules: {
          isRequired: true,
          lessThanValue: props.availableBalance,
          greaterThanValue: !props.lowBalCheck && this.minGrantAmount,
        },
        messages: {
          isRequired: "Please enter grant amount.",
          lessThanValue:
            "The grant amount entered exceeds the account balance. Please enter a value less than the account balance.",
          greaterThanValue: "Enter a minimum of $500.",
        },
      },
      date: {
        value: props.date || "",
        valid: "",
        touched: false,
      },
      isCalenderOpen: false,
      showAllSharesWarning: false,
      grantAmountChange: false,
      entireBalanceWarning: false
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
    this.handleBlurChange = this.handleBlurChange.bind(this);
    this.runFormValidation = this.runFormValidation.bind(this);
  }
   componentWillReceiveProps()
  {
    if(!this.props.allocPrefState){
      this.setState({
        grantAmountChange:false
      })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.individualValidator !== this.props.individualValidator) {
      this.runFormValidation();
    }
    
    if (
      prevProps.amount !== this.props.amount ||
      prevProps.amountLocked !== this.props.amountLocked
    ) {
      this.setState(
        (prevState) => ({
          amount: {
            ...prevState.amount,
            valid: "",
            value: this.props.amount,
            disabled: this.props.amountLocked,
          },          
          grantAmountChange: (prevProps.allShares || prevProps.allSharesAllPools) ? false : true
        }),
        this.handleFormChange
      );
    }
    if (prevProps.availableBalance !== this.props.availableBalance) {
      this.setState(
        (prevState) => ({
          amount: {
            ...prevState.amount,
            validationRules: {
              isRequired: true,
              lessThanValue: this.props.availableBalance,
              greaterThanValue: !this.props.lowBalCheck && this.minGrantAmount,
            },
          },
        }),
        this.handleFormChange
      );
    }
  }

  issueDateChangeHandler = (value) => {
    if (value === "calendar") {
      this.setState({
        isCalenderOpen: true,
        grantAmountChange: false
      });
    } else {
      this.setState(
        (prevState) => ({
          date: { ...prevState.date, value: "ASAP", touched: true },
          isCalenderOpen: false,
        }),
        this.handleFormChange
      );
    }
  };

  disabledDate = (current) => current && current < moment().subtract(1, "days");

  calenderChange = (date, dateString) => {
    this.setState(
      (prevState) => ({
        date: { ...prevState.date, value: dateString, touched: true },
        isCalenderOpen: false,
      }),
      this.handleFormChange
    );
  };

  formatData = () => ({
    data: {
      startDate: this.getStartDate(this.state.date.value),
      userSelectedDateVal: this.state.date.value,
      grantAmount: this.state.amount.value,
    },
    isFormValid: this.checkFormValid(this.state),
    allocPref: this.state.grantAmountChange ? "weightedAllocations" : ''
  });

  handleBlurChange = () => {
    this.setState((prevState, props) => {
      const diff =
        parseFloat(props.availableBalance) - parseFloat(prevState.amount.value);
      if (diff >= 0 && diff <= 500) {
        return {
          showAllSharesWarning: true,
        };
      }
    });
  };

  showEntireBalanceWarning = () => {
    this.setState({
      showAllSharesWarning: false,
      entireBalanceWarning: true
    });
  };

  hideEntireBalanceWarning = () => {
    this.setState({
      entireBalanceWarning: false,
      showAllSharesWarning: false
    });
  };

  entireBalanceSuccess = () => {
    this.setState({
      entireBalanceWarning : false
    });
    this.props.confirmWithPopup()
  }

  setavailableBalance = () => { 
    return formatter({
      value: this.props.availableBalance,
      fieldSuffix: 'Dollars',
    })     
  };
  
  getStartDate = (dateVal) => {
    if (dateVal === "" || dateVal === "ASAP") {
      return "";
    }
    return moment(dateVal, "MM/DD/YYYY").format("L");
  };

  handleDatePicker = (open) => {
    if (!open) {
      this.setState({
        isCalenderOpen: false,
      });
    }
  };

  render() {
    const { isCalenderOpen, amount, date, showAllSharesWarning, entireBalanceWarning } = this.state;
       let calendarLabel = "Pick a date";
    if (date.value && date.value !== "ASAP") {
      calendarLabel = date.value;
    }
    return (
      <>
        <FormContainer>
          <Row>
            <Col lg={8}>
              <Form.Item
                colon={false}
                label={<LabelWrapper>Schedule issue date</LabelWrapper>}
              >
                <InputWrapper>
                  <GrantDropdown
                    aria-label="Issue Data"
                    role={false}
                    id="selASAP"
                    defaultValue={date.value ? "calendar" : "ASAP"}
                    onSelect={this.issueDateChangeHandler}
                  >
                    <Select.Option value="ASAP">
                      <SelectOptionWrapper>ASAP</SelectOptionWrapper>
                    </Select.Option>
                    <Select.Option value="calendar">
                      <SelectOptionWrapper>{calendarLabel}</SelectOptionWrapper>
                    </Select.Option>
                  </GrantDropdown>
                  {date.value &&
                    isFutureDate(moment(date.value, "MM/DD/YYYY")) && (
                      <ErrorMsgWrap noLetterSpace className="notice">
                        Please note:
                        <AlertContent
                          page={"Recommend a Grant"}
                          type={[Types.PAGE_PLEASE_NOTE]}
                          keyProperty={"Send request"}
                          property={"field_please_note_content"}
                          html={true}
                          defaultMessage={
                            "We do our best to send the grant on the requested date."
                          }
                        />
                      </ErrorMsgWrap>
                    )}
                </InputWrapper>
                <GrantDatePicker
                  displayNone
                  placeholder="Start Date"
                  format="MM/DD/YYYY"
                  disabledDate={this.disabledDate}
                  open={isCalenderOpen}
                  onChange={this.calenderChange}
                  onOpenChange={this.handleDatePicker}
                  value={
                    !date.value || date.value === "ASAP"
                      ? null
                      : moment(date.value, "MM/DD/YYYY")
                  }
                />
              </Form.Item>
            </Col>
            <Col lg={{ span: 8, offset: 2 }}>
              <Form.Item
                colon={false}
                label={<LabelWrapper>Grant Amount</LabelWrapper>}
              >
                <InputWrapper>
                  <CurrencyInput
                    id={"txtWholeGrantAmount"}
                    focus={true}
                    name="amount"
                    id="txtamount"
                    label="grant-amount"
                    aria-label="grant amount"
                    placeholder="Enter grant amount"
                    maxLength={150}
                    onChange={this.handleInputChange}
                    value={amount.value}
                    disabled={amount.disabled}
                    onBlur={this.handleBlur}
                  />
                  {amount.valid && (
                    <ErrorMsgWrap>{amount.messages[amount.valid]}</ErrorMsgWrap>
                  )}
                  {this.props.lowBalCheck && (
                    <ErrorMsgWrap className="notice">
                      Please note:
                      <AlertContent
                        page={"Recommend a Grant"}
                        type={[Types.PAGE_PLEASE_NOTE]}
                        keyProperty={"Low balance"}
                        property={"field_please_note_content"}
                        html={true}
                        defaultMessage={
                          "Since your account balance is below $500.00, you can only proceed with Entire balance of investment option."
                        }
                      />
                    </ErrorMsgWrap>
                  )}
                </InputWrapper>
              </Form.Item>
            </Col>
          </Row>
        </FormContainer>
        <ErrorPopup
          title={
            <AlertContent
              page={"Recommend a Grant"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Low Pool Balance"}
              property={"field_header"}
              html={true}
              defaultMessage={"Warning"}
            />
          }
          primaryCtaLabel={
            <AlertContent
              page={"Recommend a Grant"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Low Pool Balance"}
              property={"field_alert_button1_text"}
              html={true}
              defaultMessage={"Ok"}
            />
          }
          show= {showAllSharesWarning}
          primaryCta= {this.showEntireBalanceWarning}
          onPrimaryCancel= {true}
          secondaryCta= {this.hideEntireBalanceWarning}
          className = {"grantEntireBalPopup1"}
        >
          <AlertWrap>
            <AlertContent
              page={"Recommend a Grant"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Low Pool Balance"}
              property={"field_description"}
              html={true}
              defaultMessage={
                "This will discard your changes. Are you sure you want to move forward?"
              }
            />
          </AlertWrap>
        </ErrorPopup>
  {/* #popup2**** */}
        <ErrorPopup
          title={
            <AlertContent
              page={"Recommend a Grant"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Entire Pool Balance"}
              property={"field_header"}
              html={true}
              defaultMessage={"Warning"}
            />
          }
          primaryCtaLabel={
            <AlertContent
              page={"Recommend a Grant"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Entire Pool Balance"}
              property={"field_alert_button1_text"}
              html={true}
              defaultMessage={"Ok"}
            />
          }
          show={entireBalanceWarning}
          primaryCta = {this.entireBalanceSuccess}
          secondaryCta = {this.hideEntireBalanceWarning}
          onPrimaryCancel={true}
          className = {"grantEntireBalPopup"}
          availableBalance ={this.setavailableBalance()}
        >
          <AlertWrap>
            <AlertContent
              page={"Recommend a Grant"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Entire Pool Balance"}
              property={"field_description"}
              html={true}
              defaultMessage={
                "This will discard your changes. Are you sure you want to move forward?"
              }
            />
          </AlertWrap>
        </ErrorPopup>
      </>
    );
  }
}

OneTimeGrantsForm.propTypes = {
  allShares: PropTypes.bool,
  allSharesAllPools: PropTypes.bool,
  allocPrefState: PropTypes.bool,
  amount: PropTypes.number,
  amountLocked: PropTypes.bool,
  availableBalance: PropTypes.string,
  date: PropTypes.string,
  handleFormChange: PropTypes.func,
  individualValidator: PropTypes.bool,
  lowBalCheck: PropTypes.bool,
}

export default OneTimeGrantsForm;
